export enum ConversionTypeEnum {
  VOXEL_RADIO = 'voxel_radio' as any,
  VOXEL_SELECT = 'voxel_select' as any,
  PICKUP_CENTER_VOXEL_SELECT = 'pickup_center_voxel_select' as any,
  NONE = 'none' as any
}
